<template>
    <div :class="['session-card', { 'is-signed': event.signed_up, 'is-past': event.past }]"
         :style="borderStyle" @click="$emit('open', event)">
        <div class="session-time">
            <span>{{ startTime }}</span>
            <span class="to">{{ endTime }}</span>
        </div>
        <div class="session-body">
            <div class="session-name">{{ event.name }}</div>
            <div v-if="metaLine" class="session-meta">{{ metaLine }}</div>
            <div class="session-tags">
                <span v-if="event.signed_up" class="badge signed"><i class="fa-solid fa-check"></i> {{ $t('signedUp') }}</span>
                <template v-else>
                    <span v-if="event.requires_membership && !event.membership_ok" class="badge warn">
                        <i class="fa-solid fa-id-card"></i> {{ $t('membershipRequired') }}
                    </span>
                    <span v-else-if="event.full" class="badge full">{{ $t('full') }}</span>
                    <span v-else-if="event.capacity > 0" class="badge free">{{ freeSpots }} {{ $t('freeSpots') }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'SessionCard',
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    emits: ['open'],
    computed: {
        startTime() {
            return moment(this.event.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        },
        endTime() {
            const end = moment(this.event.end, 'YYYY-MM-DD HH:mm:ss');
            return end.isValid() ? end.format('HH:mm') : '';
        },
        metaLine() {
            const parts = [];
            if (this.event.room_name) parts.push(this.event.room_name);
            if (this.event.trainer_name && this.event.trainer_name.trim()) parts.push(this.event.trainer_name.trim());
            return parts.join(' · ');
        },
        freeSpots() {
            return Math.max(0, this.event.capacity - this.event.attendance);
        },
        borderStyle() {
            // A signed-up session keeps its success-green accent (handled in CSS); otherwise use the session
            // type colour when one is defined.
            if (this.event.signed_up || !this.event.color) return {};
            return { borderLeftColor: this.event.color };
        }
    }
};
</script>
